// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: true,

  environment: window.location.origin.includes(AppConstants.CNFG_ENVT_DEV) ? AppConstants.ENVT_DEV : 
				window.location.origin.includes(AppConstants.CNFG_ENVT_SI) ? AppConstants.ENVT_SI :
				window.location.origin.includes(AppConstants.CNFG_ENVT_LOCAL) ? AppConstants.ENVT_LOCAL : AppConstants.ENVT_PROD
};

import { AppConstants } from 'src/app/constants/app-constants';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
